
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/affiliate-dashboard",
      function () {
        return require("private-next-pages/affiliate-dashboard/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/affiliate-dashboard"])
      });
    }
  